import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ChannelListPage" */
	'pages/notification/Channel/ChannelListPage'));

export default [{ component, exact: true, path: '/stonecode_notification_channels' }];
